import React from 'react'
import Contact from '../components/Contact'

function ContactComp() {
  return (


    <>
    
    <Contact/>
    </>
  )
}

export default ContactComp